import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c82645e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "font-bold" }

import { PropType } from 'vue';
import { ChecklistViewModel } from '../../ecs/completable/Completable';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecursiveChecklistReportComponent',
  props: {
  checklist: {
    type: Object as PropType<ChecklistViewModel>,
    required: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_RecursiveChecklistReportComponent = _resolveComponent("RecursiveChecklistReportComponent", true)!

  return (_openBlock(), _createElementBlock("ul", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.checklist.children, (child) => {
      return (_openBlock(), _createElementBlock("li", {
        key: child.description.description
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(child.description.description) + ": ", 1),
          _createElementVNode("p", null, _toDisplayString(child.compromised ? 'Incorrect action' : 'Correct action'), 1)
        ]),
        _createVNode(_component_RecursiveChecklistReportComponent, { checklist: child }, null, 8, ["checklist"])
      ]))
    }), 128))
  ]))
}
}

})